module.exports = __webpack_public_path__ + "static/media/pz1.11a8bd50.png";